export const ErrorTypes = {
  UNSAVED_DRAFT_VARIABLE: "UNSAVED_DRAFT_VARIABLE",
  OVERLAPPING_VARIABLE: "OVERLAPPING_VARIABLE",
  BASE: "BASE",
  ACTIONABLE__RELOAD: "ACTIONABLE__RELOAD",
  ACTIONABLE__EXTENSION_UPDATED: "ACTIONABLE__EXTENSION_UPDATED",
};
